/**
 * Area-of-law labels from new-case step 1 ("What area of law is this case?").
 * Shared with onboarding practice areas so both flows stay aligned.
 */
export const AREA_OF_LAW_LABELS = [
  'Civil',
  'Criminal',
  'Family',
  'Constitutional / Writ',
  'Rent / Tenancy',
  'Revenue / Land',
  'Banking / Financial Recovery',
  'Consumer Protection',
  'NAB / Accountability',
  'FIA / Cybercrime / Federal Offences',
  'Supreme Court',
  'Other',
] as const;

export type AreaOfLawLabel = (typeof AREA_OF_LAW_LABELS)[number];

/** Internal keys used in Cases.tsx `areaOfLaw` state */
export const AREA_OF_LAW_KEYS = [
  'Civil',
  'Criminal',
  'Family',
  'Writ',
  'Rent',
  'Revenue',
  'Banking',
  'Consumer',
  'NAB',
  'FIA',
  'SupremeCourt',
  'Other',
] as const;

export type AreaOfLawKey = (typeof AREA_OF_LAW_KEYS)[number];

export const AREA_OF_LAW_KEY_TO_LABEL: Record<AreaOfLawKey, AreaOfLawLabel> = {
  Civil: 'Civil',
  Criminal: 'Criminal',
  Family: 'Family',
  Writ: 'Constitutional / Writ',
  Rent: 'Rent / Tenancy',
  Revenue: 'Revenue / Land',
  Banking: 'Banking / Financial Recovery',
  Consumer: 'Consumer Protection',
  NAB: 'NAB / Accountability',
  FIA: 'FIA / Cybercrime / Federal Offences',
  SupremeCourt: 'Supreme Court',
  Other: 'Other',
};
